var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSample(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Canvas",
    transform: "translate(17185 6551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path0_fill",
    transform: "translate(-17185 -6551)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path1_fill",
    transform: "translate(-17168 -6543.21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path2_fill",
    transform: "translate(-17168.2 -6544.69)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path3_fill",
    transform: "translate(-17179.3 -6547.11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path4_fill",
    transform: "translate(-17167.8 -6541.74)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path5_fill",
    transform: "translate(-17167.6 -6540.27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path6_fill",
    transform: "translate(-17167.6 -6539.64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path7_fill",
    transform: "translate(-17172.9 -6540.93)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path8_fill",
    transform: "translate(-17173.1 -6542.4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path9_fill",
    transform: "translate(-17173.3 -6543.87)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path10_fill",
    transform: "translate(-17172.7 -6539.45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sample_svg__sample_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sample_svg__sample_svg__path11_fill",
    transform: "translate(-17178.7 -6542.95)"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path0_fill",
    d: "M 1.28216 8.26631L 4.30858 13.6032L 3.33343 6.7127L 1.55606 7.56205C 1.30909 7.68177 1.18932 7.98778 1.28216 8.26631ZM 5.85173 15.5759C 5.88504 15.8206 6.03244 16.027 6.22627 16.14C 6.35277 16.2122 6.49946 16.2397 6.64722 16.2122L 8.15671 15.9611L 10.5556 15.5562L 22.8211 13.4976C 23.2009 13.431 23.4688 13.0395 23.4086 12.6215L 22.032 2.91495C 21.9788 2.54275 21.6851 2.26421 21.3449 2.26421C 21.3042 2.26421 21.2708 2.27055 21.2308 2.27795L 17.2827 2.94172L 16.6141 3.0544L 15.9526 3.16708L 7.94269 4.50835L 5.54452 4.9126L 5.0573 4.99993C 4.87658 5.02599 4.70934 5.13198 4.60268 5.30453C 4.58248 5.33129 4.56264 5.35735 4.54882 5.39115C 4.47618 5.53623 4.44925 5.70279 4.47618 5.86829L 4.51551 6.14753L 5.85173 15.5759ZM 4.86985 3.65162L 7.59579 3.1942L 13.942 0.165854C 14.1628 0.0598623 14.403 2.04178e-07 14.65 2.04178e-07C 15.3317 2.04178e-07 15.9526 0.432067 16.2467 1.10182L 16.5741 1.68707L 21.0434 0.929278C 22.1121 0.750395 23.1077 1.57438 23.2615 2.7086L 24.6374 12.4155C 24.805 13.5701 24.0769 14.6589 23.0146 14.8385L 6.84069 17.5605C 6.74041 17.5806 6.63943 17.5866 6.5395 17.5866C 6.39351 17.5866 6.2454 17.5672 6.11181 17.5337C 6.09232 17.5337 6.07248 17.5337 6.05228 17.5337C 5.37053 17.5337 4.74973 17.1024 4.45563 16.4312L 0.146495 8.84346C -0.241153 7.87439 0.167401 6.73876 1.05502 6.31444L 3.26611 5.25804C 3.32634 4.99254 3.43973 4.72773 3.59352 4.50237C 3.90108 4.03685 4.3557 3.73894 4.86985 3.65162ZM 15.1181 1.69974C 15.0107 1.42121 14.6971 1.28211 14.437 1.40888L 12.3921 2.39028L 15.2378 1.91314L 15.1181 1.69974Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path1_fill",
    d: "M 3.50053 0.823991L 2.83189 0.929982L 2.16431 1.03633L 0.0871677 1.36874L 5.29867e-07 0.690532L 1.80359 0.404952L 2.47826 0.299313L 3.1469 0.192616L 4.34917 6.01789e-07L 4.44236 0.670461L 3.50053 0.823991Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path2_fill",
    d: "M 2.91906 0.916249L 2.25112 1.02224L 1.58355 1.12859L 0.0931915 1.36733L -1.40577e-07 0.690531L 1.22212 0.497916L 1.89076 0.391571L 2.55869 0.284876L 4.35591 -7.52237e-08L 4.44307 0.670812L 2.91906 0.916249Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path3_fill",
    d: "M 13.1194 1.75221L 12.4515 1.86489L 11.7839 1.9649L 0.186029 3.82451L 2.75747e-07 2.47585L 11.0689 0.710251L 11.7368 0.603556L 12.4047 0.497916L 15.485 -6.44774e-08L 15.6725 1.34796L 13.1194 1.75221Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path4_fill",
    d: "M 2.23128 0.339103L 2.87264 0.238745L 3.49344 0.13874L 4.34882 3.4388e-07L 4.43528 0.677503L 3.39387 0.843005L 2.63098 0.962026L 0.834472 1.24831L 0.0864598 1.36733L -3.46035e-07 0.696519L 2.23128 0.339103Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path5_fill",
    d: "M 0.568009 1.28845L 0.0733482 1.36804L -4.75799e-07 0.817299L 0.386586 0.631374L 2.56471 0.279241L 4.33571 -1.28955e-07L 4.42854 0.670812L 0.568009 1.28845Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path6_fill",
    d: "M 0.401404 -3.86864e-07L 0.0138533 0.185926L -9.97333e-07 0.0598629L 0.401404 -3.86864e-07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path7_fill",
    d: "M 4.34917 -3.33133e-07L 4.43563 0.671517L 0.0864596 1.36874L -6.38003e-07 0.691236L 4.34917 -3.33133e-07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path8_fill",
    d: "M 4.34882 -2.47163e-07L 4.43528 0.676799L 0.0864585 1.36698L -3.46035e-07 0.695814L 4.34882 -2.47163e-07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path9_fill",
    d: "M 5.29867e-07 0.691237L 4.3559 1.07462e-08L 4.44236 0.669756L 0.0935463 1.36099L 5.29867e-07 0.691237Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path10_fill",
    d: "M 3.29962 0.849344L 0.968058 1.22155L 0.0864585 1.36099L -3.24408e-07 0.690533L 3.12599 0.192616L 4.34882 -4.29849e-07L 4.39595 0.32537L 4.44236 0.67046L 3.29962 0.849344Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sample_svg__sample_svg__path11_fill",
    d: "M 4.65001 2.36417e-07L 5.26479 5.09149L 0.614781 5.75526L 4.00103e-07 0.66377L 4.65001 2.36417e-07Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSample);
export default __webpack_public_path__ + "static/media/sample.47d6fedc5289e2a54ca14a1779d3aefa.svg";
export { ForwardRef as ReactComponent };